import React, { Component } from 'react';
import getLocale from '../../../i18n/getLocale';

import ScheduleGradeStaffRemainingAdd from './ScheduleGradeStaffRemainingAdd';

class ScheduleGradeStaffRemainingTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      remaining_staffs: this.props.remaining_staffs,
      types_list: this.props.types_list,
    };

    this.locale = getLocale();

  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.remaining_staffs) && newProps.types_list.length > 0) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        types_list: newProps.types_list,
        remaining_staffs: newProps.remaining_staffs,
        loaded: 1,
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.tituloForaDeEscala}</h3>
  <hr/>
  {(this.state.remaining_staffs === null || typeof this.state.remaining_staffs === 'undefined') ?  <div><small><em>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.nenhumChefeDeEquipamentoDisponIvel}</em></small><hr/></div>
  :
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.tabela.Tripulante}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.tabela.Matricula}</th>
          <th className="text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.tabela.Designacao}</th>
          <th className="col-md-7 text-center">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabForaDaEscala.tabela.AlocarNaEscala}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.remaining_staffs).map(function(k) {
          return (
            <tr>
              <td>{self.state.remaining_staffs[k].staff.name}</td>
              <td className="text-center">{self.state.remaining_staffs[k].staff.inscription}</td>
              <td>{self.state.remaining_staffs[k].designation.name}</td>
              <td>
                <ScheduleGradeStaffRemainingAdd schedule_id={self.props.schedule_id} schedule_grade_id={self.props.schedule_grade_id}  updateData={self.props.updateData} updated={self.props.updated} handleAlert={self.props.handleAlert} staff_id={self.state.remaining_staffs[k].staff.id} date_start={self.props.date_start} date_finish={self.props.date_finish} types_list={self.props.types_list} schedule_grade_initials_secondary={self.props.schedule_grade_initials_secondary} schedule_grade_initials_vacation={self.props.schedule_grade_initials_vacation} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }

</div>
    );
  }
}


export default ScheduleGradeStaffRemainingTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeStaffRemainingTab.js